<template>
    <div class="page">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/messages.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Sent Messages</h2>
                <ul class="links">
                    <li style="transform: translateY(-2px)">
                        <button
                            class="openSettings"
                            @click.prevent="deleteOn = !deleteOn"
                            type="button"
                            name="button"
                        >
                            <img class="bin" v-if="!deleteOn" src="@/assets/bin.svg" /><img
                                v-else
                                class="bin"
                                src="@/assets/bin-red.svg"
                            />
                        </button>
                    </li>
                    <li>
                        <router-link class="cancel" :to="{ name: 'proMessages' }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <div class="" v-if="!$store.state.messagesLoaded">
                <pre-loader-item v-for="n in 5" :key="n" />
            </div>

            <ul id="messages" v-else-if="sentMessages.length > 0">
                <message-item
                    v-for="message in sentMessages"
                    :key="message.id"
                    :message="message"
                    :deleteOn="deleteOn"
                    :isSentMessage="true"
                    @onDeleteMessage="deleteMessage"
                />
            </ul>

            <span class="info" v-else>You have no sent messages</span>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import PreLoaderItem from "@/components/App/Pre-loader-item";
import MessageItem from "@/components/Pro/Messages/Message-item";
import { XIcon } from "vue-feather-icons";
export default {
    name: "inbox",
    components: {
        PreLoaderItem,
        MessageItem,
        XIcon,
        FadeImage,
    },
    data() {
        return {
            deleteOn: false,
        };
    },
    created() {
        this.$store.dispatch("getSentMessages");
    },
    computed: {
        sentMessages() {
            return this.$store.state.sentMessages;
        },
    },
    methods: {
        deleteMessage(msg) {
            window.axios.delete("/message/" + msg.id).then(() => {
                var index = this.$store.state.sentMessages.findIndex((message) => {
                    return message.id == msg.id;
                });

                this.$store.state.sentMessages.splice(index, 1);
                this.$notify("Sent message deleted");
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
